// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"46":"c0ebfe16ff11d57b024d","110":"f38cc531bb66db1a9482","615":"21e1291c398cd9cce7d0","804":"92fb5748d8f360443b52"}[chunkId] + ".js";
};